import React from 'react';

interface LoadingIndicatorProps {
  label: string;
  className?: string;
  compact?: boolean;
  subtle?: boolean;
  showLines?: boolean;
  inline?: boolean;
}

const joinClasses = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(' ');

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  label,
  className,
  compact = false,
  subtle = false,
  showLines = true,
  inline = false,
}) => {
  const dotsClassName = joinClasses('system-loading-dots', compact && 'system-loading-dots-compact');

  if (inline) {
    return (
      <span className={joinClasses('system-loading-inline', className)} role="status" aria-live="polite">
        <span className={dotsClassName} aria-hidden="true">
          <span className="system-loading-dot" />
          <span className="system-loading-dot" />
          <span className="system-loading-dot" />
        </span>
        <span className="visually-hidden">{label}</span>
      </span>
    );
  }

  return (
    <div
      className={joinClasses(
        'system-loading-status-card',
        subtle && 'system-loading-status-card-subtle',
        compact && 'system-loading-status-card-compact',
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <span className={dotsClassName} aria-hidden="true">
        <span className="system-loading-dot" />
        <span className="system-loading-dot" />
        <span className="system-loading-dot" />
      </span>
      {showLines && (
        <>
          <span className="system-loading-line page-skeleton-shimmer" aria-hidden="true" />
          {!compact && <span className="system-loading-line system-loading-line-short page-skeleton-shimmer" aria-hidden="true" />}
        </>
      )}
      <span className="visually-hidden">{label}</span>
    </div>
  );
};

export default LoadingIndicator;